import { ReactNode } from 'react';
import CustomButton from './CustomButton';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: Function,
    btnText: string,
    children: ReactNode;
    action: Function,
    cancelAction?: Function
    cancelColor?: string
    isTablet?: boolean
}

const ConfrimDialog = ({ isOpen, setIsOpen, btnText, children, action, cancelColor, cancelAction, isTablet }: IConfrimDialog) => {
    return (
        <div className="relative">
            {isOpen && (
                <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                    <div className={`bg-white shadow-lg p-6 rounded-lg w-1/5 min-w-[500px] max-h-[80vh] overflow-y-auto ${isTablet ? 'tablet:w-9/10 tablet:min-w-0' : 'tablet:w-96'}`}>
                        <h2 className="mb-4 font-semibold text-black tablet:text-base text-xl">Pulse On Ship 내용:</h2>
                        {children}
                        <div className="flex justify-end gap-4 mt-6">
                            <CustomButton title={'취소'} onClick={() => {
                                cancelAction ? cancelAction() : setIsOpen(false)
                            }}
                                className={`w-30 ${cancelColor ? cancelColor : 'bg-red'}`}
                            />
                            <CustomButton title={btnText} onClick={() => action()} className={'w-30 bg-primary'} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConfrimDialog;